export enum NetMaskVariants {
  FOUR_SIDED = 1,
  SIX_SIDED = 2,
}
